import { type ComponentPublicInstance, type InjectionKey } from 'vue'
import { type DoActionType } from '../hooks'

export const stepGroupProps = {
  modelValue: {
    type: [String, Number],
    default: ''
  }
}

export type StepGroupInject = {
  modelValue: string | number
  link: (child: ComponentPublicInstance) => void
  changeEvent: (step: string | number) => void
  doAction: (action: DoActionType, step: string | number) => void
}

export const stepGroupContextKey: InjectionKey<StepGroupInject> = Symbol(
  'stepGroupContextKey'
)
